var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CardHeaderCore, } from '@core-front/card';
import { getBackgroundColorClass, } from '@telia-front/colors';
import { CardContext } from '../card/card';
const CardHeader = (props) => {
    const { background, children, className } = props, rest = __rest(props, ["background", "children", "className"]);
    const { background: cardColor } = React.useContext(CardContext);
    const getBackground = () => {
        if (background) {
            return background;
        }
        switch (cardColor) {
            case 'neutral-1':
                return 'primary-3';
            case 'transparent':
                return;
            default:
                return 'neutral-1';
        }
    };
    const BEM = () => {
        const classArray = [];
        const background = getBackground();
        if (background) {
            classArray.push(getBackgroundColorClass(background));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(CardHeaderCore, Object.assign({ className: BEM() }, rest), children));
};
export { CardHeader as default, };
